import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const reportsAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = reportsAdapter.getInitialState()

export const reportsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getReports: builder.query({
            query: ({ groupId }) => ({
                url: `/api/reports/${groupId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const selectedTasks = responseData.tasks?.map(task=>task._id)
                const newObj = {...responseData, selectedTasks}
                return newObj
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Report', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Report', id }))
                    ]
                } else return [{ type: 'Report', id: 'LIST' }]
            }
        }),
        getStudentReport: builder.query({
            query: ({ groupId }) => ({
                url: `/api/reports/s/${groupId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
        }),
    }),
})

export const {
    useGetReportsQuery,
    useLazyGetReportsQuery,  
    useLazyGetStudentReportQuery
} = reportsApiSlice

// returns the query result object
export const selectReportsResult = reportsApiSlice.endpoints.getReports.select()

// creates memoized selector
const selectReportsData = createSelector(
    selectReportsResult,
    reportsResult => reportsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllReports,
    selectById: selectReportById,
    selectIds: selectReportIds
    // Pass in a selector that returns the reports slice of state
} = reportsAdapter.getSelectors(state => selectReportsData(state) ?? initialState)